import Choices from "choices.js";
// import SimpleBar from 'simplebar/dist/simplebar.min';

export default function(selectEls) {
    [].forEach.call(selectEls, select => {
      new Choices(select,{
        searchEnabled: false,
        shouldSort: false,
        classNames: {
          containerOuter: 'choices ' + select.dataset.class
        },
        itemSelectText: '',
      });
      // const selectWrapper = item.previousElementSibling;
      // const content = selectWrapper.querySelector('.js-Dropdown-list');
      // item.addEventListener('change', () => {
      //   selectWrapper.classList.add('is-changed')
      // });
      // new SimpleBar(content, {
      //   // forceVisible: true,
      //   scrollbarMinSize: 30,
      //   autoHide: false,
      //   forceVisible: 'y'
      // });
    })
}
